import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Truck, Check } from "lucide-react";
import { useShipping } from "@/hooks/useShipping";
import { formatCurrency } from "@/lib/product";

/** Compacte gratis-verzendingsmeter die op mobiel onder de header meescrollt (alle pagina's). */
export const MobileShippingBar = () => {
  const { t, i18n } = useTranslation();
  const verzending = useShipping();
  const zichtbaar = Boolean(verzending?.gratisVanaf);

  useEffect(() => {
    document.documentElement.style.setProperty("--mobiele-balk", zichtbaar ? "48px" : "0px");
    return () => document.documentElement.style.setProperty("--mobiele-balk", "0px");
  }, [zichtbaar]);

  if (!zichtbaar) return null;
  const gehaald = verzending.gratis;
  const voortgang = gehaald
    ? 100
    : Math.min(100, Math.round(((verzending.gratisVanaf - verzending.tekortVoorGratis) / verzending.gratisVanaf) * 100));

  return (
    <div className="sticky top-[68px] z-30 h-12 border-b bg-background/95 px-4 backdrop-blur sm:hidden" data-testid="mobile-shipping-bar">
      <div className="flex h-full flex-col justify-center gap-2">
        <p className="flex items-center gap-2 truncate text-xs font-medium leading-none">
          {gehaald ? (
            <Check className="h-3.5 w-3.5 shrink-0 text-[hsl(var(--success))]" aria-hidden="true" />
          ) : (
            <Truck className="h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
          )}
          <span className="truncate" data-testid="mobile-shipping-bar-text">
            {gehaald
              ? t("shipping.nudgeReached", { vanaf: formatCurrency(verzending.gratisVanaf, i18n.language) })
              : t("shipping.nudgeRemaining", { ontbreekt: formatCurrency(verzending.tekortVoorGratis, i18n.language) })}
          </span>
        </p>
        <div className="h-1 w-full overflow-hidden rounded-full bg-secondary">
          <div className="h-full rounded-full bg-primary transition-[width] duration-500 ease-out" style={{ width: `${voortgang}%` }} data-testid="mobile-shipping-bar-progress" />
        </div>
      </div>
    </div>
  );
};
